import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';

import Section from '../../common/Section';
import CtaButton from '../../common/CtaButton';

const Wrapper = styled(Section)`
  padding: var(--default-vertical-padding) var(--default-horizontal-padding);
  padding-top: 0;
  display: flex;
  justify-content: center;
`;

const getClientName = userAgent => {
  if (userAgent.isiPhone || userAgent.isiPad || userAgent.isiPod) {
    return 'iOS';
  }

  if (userAgent.isAndroid) {
    return 'Android';
  }

  if (userAgent.isWindows) {
    return 'Windows';
  }

  if (userAgent.isMac) {
    return 'macOS';
  }

  return 'Windows'; // default to windows
};

class DownloadApp extends React.Component {
  render() {
    const client = getClientName(this.context);

    const trackingData = {
      title: `Download ${client} App`,
      from: 'Download app section',
    };

    return (
      <Wrapper>
        <CtaButton color="red" openInNewTab link="/download-app" trackingData={trackingData}>
          <FormattedMessage
            id="download.cta.label"
            defaultMessage="Download {client} App"
            values={{ client }}
          />
        </CtaButton>
      </Wrapper>
    );
  }
}

DownloadApp.contextTypes = {
  isiPhone: PropTypes.bool,
  isiPad: PropTypes.bool,
  isIpod: PropTypes.bool,
  isAndroid: PropTypes.bool,
  isMac: PropTypes.bool,
  isWindows: PropTypes.bool,
};

export default DownloadApp;



// WEBPACK FOOTER //
// /tmp/build_83f21ab6/src/components/main/download/DownloadApp.js